// StatCard.jsx
// Client: vmfive
// Version: 1.0.0
// DS Phase 1B-2: KPI summary card for Portal dashboards.

import './StatCard.css';

/**
 * StatCard — KPI摘要卡片元件
 *
 * @param {Object}  props
 * @param {string}           props.label     - 卡片標題（灰色小字，12px）
 * @param {string|number}    props.value     - 主要數值（大字，28px/700）
 * @param {Object}           [props.trend]   - 趨勢 badge（可省略）
 * @param {'up'|'down'}      props.trend.direction - 上升或下降
 * @param {string}           props.trend.value     - 顯示文字，例如 "+12%"
 * @param {string}           [props.className]     - 額外 CSS class
 *
 * @example
 * // 有 trend badge
 * <StatCard label="總廣告數" value="128" trend={{ direction: 'up', value: '+12%' }} />
 *
 * @example
 * // 無 trend
 * <StatCard label="日預算用量" value="78%" />
 */
export default function StatCard({
  label,
  value,
  trend,
  className = '',
  ...rest
}) {
  return (
    <div className={`ds-stat-card ${className}`} {...rest}>
      <div className="ds-stat-card__label">{label}</div>
      <div className="ds-stat-card__value">{value}</div>
      {trend && (
        <div
          className={`ds-stat-card__trend ds-stat-card__trend--${trend.direction === 'up' ? 'up' : 'down'}`}
        >
          {trend.value}
        </div>
      )}
    </div>
  );
}
